import React from 'react'

// Constants
import { SKETCH_WEBSITE } from 'constants/sketchWebsite'

// Components
import { TableComponents } from 'components/Table'
import Dropdown from 'components/Dropdown'

// Local Components
import { ButtonItem, ExternalLinkItem } from '../Item'

// Local Icons
import { icons } from './icons'

// Styles
import {
  FooterWrapper,
  DropdownDivider,
  DropdownItem,
} from './ProjectsMenu.styles'

const HelpMenu = () => (
  <FooterWrapper>
    <Dropdown
      toggle={<ButtonItem icon={icons.LifeBelt} text="Help With Sketch" />}
      placement="top"
      contentPadding="8px">
      <DropdownItem>
        <ExternalLinkItem
          icon={icons.Home}
          href={`${SKETCH_WEBSITE}/home`}
          text="sketch.com"
        />
      </DropdownItem>
      <DropdownItem>
        <ExternalLinkItem
          icon={icons.SketchLogo}
          href={`${SKETCH_WEBSITE}/downloads/mac`}
          text="Download the Mac App"
        />
      </DropdownItem>

      <DropdownDivider />

      {/* This is used here since style-wise is the same component */}
      <DropdownItem>
        <TableComponents.TableHeaderCell as="div">
          Get Help
        </TableComponents.TableHeaderCell>
      </DropdownItem>

      <DropdownItem>
        <ExternalLinkItem
          icon={icons.Notebook}
          href={`${SKETCH_WEBSITE}/docs/`}
          text="Documentation"
        />
      </DropdownItem>
      <DropdownItem>
        <ExternalLinkItem
          icon={icons.QuestionMark}
          href={`${SKETCH_WEBSITE}/support/`}
          text="Frequently Asked Questions"
        />
      </DropdownItem>
      <DropdownItem>
        <ExternalLinkItem
          icon={icons.MailEnvelope}
          href={`${SKETCH_WEBSITE}/support/contact/`}
          text="Contact Us"
        />
      </DropdownItem>
    </Dropdown>
  </FooterWrapper>
)

export default HelpMenu
